import React, { useEffect, useRef, useState } from "react";
import Picker from "@emoji-mart/react";
import { BsFileTextFill } from "react-icons/bs";
import { IoMdClose } from "react-icons/io";
// import { v4 as uuid } from 'uuid'
import { useIsMutating, useQuery, useQueryClient } from "@tanstack/react-query";
import { ClientMessage } from "../client-message";
import { UserMessage } from "../user-message";
import { TemplateTransbordo } from '../templates/TemplateTransbordo'
import { FileButton } from '../file-button'
import { apiWhatsApp } from '../../../../services/api'
import { MessageProps, TemplateProps, useChatWhatsApp } from '../../../../context/ChatWhatsAppContext'
import { format } from "date-fns";
import { useAuth } from "../../../..//context/AuthContext";
// import { useModal } from "../../../../../hooks/ModalContext";
import { Loader } from "../../../generics/loader";
import { GrEmoji } from "react-icons/gr";
import { IoSend } from "react-icons/io5";
import { useFilaTransbordo, QueueProps } from '../../../../context/FilaTransbordoContext'
import { useDividas } from "../../../../context/DividasContext";
import { CustomModal } from "../../../Modal/CustomModal";
import { useChatDraft } from '../../../../hooks/useChatDraft'
import { useFileUpload } from "../../../../context/UploadFilesContext";
import { ModalFileUploadError } from '../../../Modal/components/modal-file-upload-error'
import { Mic, Pause, Play, Square, Trash2 } from "lucide-react";
import { TransferModal } from "../../../Modal/components/tranferencia-whats";


interface ChatBoxProps {
  type: string;
}

interface MessagesChatProps {
  file?: {
    downloaded: [],
    attendantHasReceivedUpdate: boolean,
    url: string
    name?: string
  },
  read: {
    value: boolean
  },
  fromAttendant: boolean,
  _id: string,
  onlySave: boolean,
  type: string,
  chat: string,
  text?: string,
  createdAt: string,
  attendant?: string,
  template?: TemplateProps

}

export const ChatBox = ({ type }: ChatBoxProps) => {
  const queryClient = useQueryClient()
  const [showEmoji, setShowEmoji] = useState(false);
  const { enviarMessages, endChat, sendDoc, endOnTemplateChat } = useChatWhatsApp()
  const [messagesChat, setMessageChat] = useState<MessagesChatProps[]>([])
  const { devedorFilaSelected, getDevedorFilaSelected, fila, clearSelectedFila } = useFilaTransbordo()
  const { clearDividas } = useDividas()
  // const { setModal } = useModal()
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const { cookies } = useAuth()
  const isMutationChat = useIsMutating({ mutationKey: ['chat'] })
  const [showModal, setShowModal] = useState(false)
  const [showModalTransfer, setShowModalTransfer] = useState(false)
  const { getDraft, saveDraft, clearDraft } = useChatDraft(devedorFilaSelected?._id);

  // --- Gravação de áudio ---
  const [isRecording, setIsRecording] = useState(false);
  const [recordingDuration, setRecordingDuration] = useState(0);
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const audioChunksRef = useRef<Blob[]>([]);
  const recordingMimeTypeRef = useRef<string>("");
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

  // --- Revisão de áudio ---
  const [audioBlob, setAudioBlob] = useState<Blob | null>(null);
  const [audioUrl, setAudioUrl] = useState<string | null>(null);
  const [isPlayingPreview, setIsPlayingPreview] = useState(false);
  const audioPreviewRef = useRef<HTMLAudioElement>(null);
  const [isSendingAudio, setIsSendingAudio] = useState(false);
  const [isPreparing, setIsPreparing] = useState(false);


  const [fileState, setFileState] = useState<File | null>(null)
  const [text, setText] = useState("");


  const clientMess = messagesChat && Array.isArray(messagesChat) && messagesChat?.find((item: MessagesChatProps) => !item?.attendant && item._id) ? true : false

  const attendantFirstMessage = messagesChat && Array.isArray(messagesChat) && messagesChat?.find((item: MessagesChatProps) => item?.attendant && item._id) ? true : false


  useEffect(() => {
    const data = fila.find(item => item._id === devedorFilaSelected?._id)
    getDevedorFilaSelected(data || {} as QueueProps)
  }, [fila])

  const scrollToBottom = () => {
    const scrollContainer = scrollContainerRef.current;
    // Verifica se o contêiner de rolagem existe

    if (scrollContainer) {
      // Rola para o final do contêiner
      scrollContainer.scrollTop = scrollContainer.scrollHeight;
    }
  };

  async function getMessages() {
    if (devedorFilaSelected?._id) {
      return await apiWhatsApp.get(`/message/?updates=true&chatId=${devedorFilaSelected._id}`, { params: { chatId: devedorFilaSelected._id, updates: 'true' }, headers: { token: cookies?.whatsapp?.token } })
    }
  }

  const { data, refetch } = useQuery({
    queryFn: () => getMessages(),
    queryKey: ['firstMessages'],
    refetchInterval: 3000,
    refetchIntervalInBackground: true,
  })

  useEffect(() => {
    scrollToBottom()
  }, [messagesChat])

  useEffect(() => {
    setMessageChat(data?.data)
  }, [data?.data, devedorFilaSelected._id])

  useEffect(() => {
    refetch()
    setMessageChat(data?.data)
  }, [devedorFilaSelected._id])

  useEffect(() => {
    if (devedorFilaSelected._id) {
      setText(getDraft());
    }
  }, [devedorFilaSelected._id]);

  useEffect(() => {
    if (!devedorFilaSelected._id) return;

    const timeout = setTimeout(() => {
      if (text.trim().length > 0) {
        saveDraft(text);
      } else {
        clearDraft();
      }
    }, 300);

    return () => clearTimeout(timeout);
  }, [text, devedorFilaSelected._id]);

  async function handleSend(dataMess: MessageProps) {
    await enviarMessages(dataMess)
    clearDraft();
    setText('');
    setShowEmoji(false);

    await queryClient.refetchQueries({ queryKey: ['firstMessages'] })
  }

  async function handleFileSelect(file: File) {
    setFileState(file)
  };

  function clearFile() {
    setFileState(null)
  }

  function getBase64(file: File) {
    return new Promise((resolve) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result);
      };
    });
  }


  async function sendFile(file: File) {
    const base64 = await getBase64(file)
    const token = cookies?.whatsapp?.token || ''
    const chat = devedorFilaSelected._id || ''
    const [docType, data] = String(base64)?.split(';')
    const [, fileURL] = String(data)?.split(',')
    const docTypeFormated = docType?.replace('data:', '')
    const fileName = `${file.name}`

    await sendDoc({ chat, token, file: fileURL, contentType: docTypeFormated, fileName })
    setFileState(null)
  }

  function handleEmojiClick(emoji: any) {
    setText(text + emoji.native);
  }


  // Libera URL do objeto ao desmontar
  useEffect(() => {
    return () => { if (audioUrl) URL.revokeObjectURL(audioUrl); };
  }, [audioUrl]);

  function formatDuration(seconds: number) {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  }

  async function startRecording() {
    if (!navigator.mediaDevices?.getUserMedia) {
      alert("Seu navegador não suporta gravação de áudio.");
      return;
    }
    try {
      setIsPreparing(true);
      setAudioBlob(null);
      setAudioUrl(null);

      const allDevices = await navigator.mediaDevices.enumerateDevices();
      const audioInputs = allDevices.filter(d => d.kind === 'audioinput');
      const virtualKeywords = ['virtual', 'teams', 'zoom', 'discord', 'cable', 'blackhole', 'soundflower', 'loopback'];
      const realMic = audioInputs.find(d =>
        !virtualKeywords.some(kw => d.label.toLowerCase().includes(kw))
      ) || audioInputs[0];

      let stream: MediaStream | null = null;
      try {
        stream = await navigator.mediaDevices.getUserMedia({
          audio: {
            deviceId: realMic?.deviceId ? { ideal: realMic.deviceId } : undefined,
            echoCancellation: true,
            noiseSuppression: true,
            autoGainControl: true,
            channelCount: 1,
          }
        });
      } catch {
        stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      }

      if (!stream) throw new Error("Não foi possível acessar o microfone.");

      let mediaRecorder: MediaRecorder;
      try {
        const workerOptions = {
          encoderWorkerFactory: (_: any) => new Worker('/opus-media-recorder/encoderWorker.umd.js'),
          OggOpusEncoderWasmPath: '/opus-media-recorder/OggOpusEncoder.wasm',
          WebMOpusEncoderWasmPath: '/opus-media-recorder/WebMOpusEncoder.wasm',
        };
        const OpusPackage = await import('opus-media-recorder');
        const OpusMediaRecorder = (OpusPackage as any).default || OpusPackage;
        const mimeType = 'audio/ogg; codecs=opus';
        mediaRecorder = new OpusMediaRecorder(stream, { mimeType }, workerOptions) as unknown as MediaRecorder;
        recordingMimeTypeRef.current = mimeType;
      } catch {
        const mimeType = 'audio/webm';
        mediaRecorder = new MediaRecorder(stream, { mimeType });
        recordingMimeTypeRef.current = mimeType;
      }

      mediaRecorderRef.current = mediaRecorder;
      audioChunksRef.current = [];

      mediaRecorder.ondataavailable = (e: BlobEvent) => {
        if (e.data.size > 0) audioChunksRef.current.push(e.data);
      };
      mediaRecorder.onstop = () => {
        const type = recordingMimeTypeRef.current || 'audio/webm';
        const blob = new Blob(audioChunksRef.current, { type });
        const url = URL.createObjectURL(blob);
        setAudioBlob(blob);
        setAudioUrl(url);
        stream?.getTracks().forEach(t => t.stop());
      };

      mediaRecorder.start();
      setIsPreparing(false);
      setIsRecording(true);
      setRecordingDuration(0);
      timerRef.current = setInterval(() => setRecordingDuration(d => d + 1), 1000);
    } catch (error: any) {
      setIsPreparing(false);
      if (error.name === 'NotAllowedError') {
        alert("Permissão de microfone negada. Permita o acesso nas configurações do navegador.");
      } else if (error.name === 'NotFoundError') {
        alert("Nenhum microfone encontrado neste dispositivo.");
      } else {
        alert(`Erro ao acessar microfone: ${error.message}`);
      }
    }
  }

  function stopRecording() {
    if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
      mediaRecorderRef.current.stop();
    }
    if (timerRef.current) { clearInterval(timerRef.current); timerRef.current = null; }
    setIsRecording(false);
  }

  function cancelRecording() {
    if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
      mediaRecorderRef.current.stop();
      mediaRecorderRef.current.stream.getTracks().forEach(t => t.stop());
    }
    if (timerRef.current) { clearInterval(timerRef.current); timerRef.current = null; }
    audioPreviewRef.current?.pause();
    if (audioUrl) URL.revokeObjectURL(audioUrl);
    setIsRecording(false);
    setIsPreparing(false);
    setRecordingDuration(0);
    setAudioBlob(null);
    setAudioUrl(null);
    setIsPlayingPreview(false);
    setIsSendingAudio(false);
  }

  async function togglePreview() {
    const el = audioPreviewRef.current;
    if (!el) return;
    if (isPlayingPreview) {
      el.pause();
      setIsPlayingPreview(false);
    } else {
      try {
        await el.play();
        setIsPlayingPreview(true);
      } catch (err) {
        setIsPlayingPreview(false);
      }
    }
  }

  async function sendAudio() {
    if (!audioBlob) return;
    setIsSendingAudio(true);
    try {
      let finalExt = 'webm';
      let finalType = audioBlob.type;
      if (recordingMimeTypeRef.current.includes('ogg') || audioBlob.type.includes('ogg')) {
        finalType = 'audio/ogg; codecs=opus';
        finalExt = 'ogg';
      }
      const file = new File([audioBlob], `audio-${Date.now()}.${finalExt}`, { type: finalType });
      await sendFile(file);
      cancelRecording();
    } catch {
      setIsSendingAudio(false);
    }
  }

  const handleKeyPress = async (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      await handleSend({
        type: 'text',
        text: !fileState ? text : '',
        onlySave: false,
        token: cookies?.whatsapp?.token || '',
        chat: devedorFilaSelected._id
      })
    }
  };


  async function handleEndChat() {
    const id_chat = devedorFilaSelected._id || ''
    const token = cookies?.whatsapp?.token || ''
    if (devedorFilaSelected && devedorFilaSelected?._id && !clientMess) await endOnTemplateChat(id_chat, token)
    if (devedorFilaSelected && devedorFilaSelected._id && clientMess) await endChat(id_chat, token)
    setMessageChat([])
    clearDividas()
    clearSelectedFila()
    setShowModal(false)
    await queryClient.refetchQueries({ queryKey: ['transbordo-atendimento'] })

  }

  const { attachments, removeAttachment, clearAttachments, isBigDuration, seIsBigDuration } = useFileUpload()

  async function handleSendFile() {
    const uploading = attachments.some(a => a.isUploading);

    if (uploading) return; // impede enviar enquanto uploada

    const uploadedFiles = attachments
      .filter(a => a.uploadedUrl)
      .map(a => { return { name: a.file.name, uploadedUrl: a.uploadedUrl!, file: a.file } });

    // nada pra enviar
    if (!text.trim() && uploadedFiles.length === 0) return;



    if (uploadedFiles?.length > 0) {
      await Promise.all(uploadedFiles.map(async item => {
        await sendDoc({
          fileName: item.file.name,
          contentType: item.file.type,
          file: item.uploadedUrl,
          url: item.uploadedUrl,
          token: cookies?.whatsapp?.token || '',
          chat: devedorFilaSelected._id
        });
      }))
    }
    clearAttachments()
  }




  return (
    <div className="w-full h-full ">
      <div className="fixed top-[186px] mt-5 h-[74vh] flex w-[20vw] flex-grow flex-col rounded-lg bg-[#EEEAE3]  ">

        <div className="flex flex-grow  flex-col  overflow-y-auto overflow-x-hidden p-4 border border-primary h-screen rounded-sm" ref={scrollContainerRef}>
          <div className="">
            {devedorFilaSelected?._id && <p className="w-full text-center text-primary font-semibold text-sm mb-4">Conversa iniciada</p>}
            {
              devedorFilaSelected?._id && messagesChat && messagesChat?.length > 0 && messagesChat?.map(mess => (
                <>
                  {
                    mess.attendant && !mess.onlySave ? <UserMessage text={mess.text || ''} time={format(new Date(mess.createdAt), 'HH:mm')} linkImage={mess?.file?.url} template={mess.template} type={mess.type} documentName={mess?.file?.name} /> : !mess.attendant && !mess.onlySave ? <ClientMessage text={mess.text || ''} type={mess.type} linkImage={mess?.file?.url} time={format(new Date(mess.createdAt), 'HH:mm')} /> : <></>
                  }
                </>
              ))
            }
            {devedorFilaSelected && devedorFilaSelected?._id && !clientMess && attendantFirstMessage && <p className="w-full text-center text-primary font-semibold text-sm mb-4">Aguardando reposta do cliente</p>}
          </div>
        </div>
        {attachments.length > 0 && (
          <div className="flex flex-wrap gap-3 px-3 py-2">
            {attachments.map(a => (
              <div
                key={a.id}
                className="group relative flex w-[220px] items-center gap-3 rounded-xl border border-gray-200 bg-white px-3 py-2 shadow-sm transition hover:shadow-md"
              >
                {/* Icon */}
                <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg bg-primary/10">
                  <svg
                    className="h-5 w-5 text-primary"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path d="M21 15V6a2 2 0 00-2-2H7l-4 4v7a2 2 0 002 2h14a2 2 0 002-2z" />
                  </svg>
                </div>

                {/* File Info */}
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-medium text-gray-800">
                    {a.file.name}
                  </p>

                  {!a.error && (
                    <p className="text-xs text-gray-400">
                      {a.isUploading ? "Enviando..." : "Pronto para envio"}
                    </p>
                  )}

                  {a.error && (
                    <p className="text-xs font-medium text-red-500">
                      Falha no upload
                    </p>
                  )}
                </div>

                {/* Remove button */}
                <button
                  onClick={() => removeAttachment(a.id)}
                  className="absolute -right-2 -top-2 flex h-6 w-6 items-center justify-center rounded-full bg-white text-gray-500 shadow transition hover:bg-red-500 hover:text-white"
                >
                  ✕
                </button>

                {/* Upload overlay */}
                {a.isUploading && (
                  <div className="absolute inset-0 rounded-xl bg-white/70 backdrop-blur-[1px] flex items-center justify-center">
                    <div className="h-4 w-4 animate-spin rounded-full border-2 border-primary border-t-transparent" />
                  </div>
                )}

                {/* Error overlay border */}
                {a.error && (
                  <div className="absolute inset-0 rounded-xl border-2 border-red-400 pointer-events-none" />
                )}
              </div>
            ))}
          </div>
        )}
        <div
          className={`${!showEmoji && "hidden"} absolute bottom-20 z-10 w-full`}
        >
          <Picker
            // data={data}
            onEmojiSelect={handleEmojiClick}
            locale={"pt"}
            previewPosition="none"
            theme="light"
            searchPosition="none"
            categories={["frequent", "people"]}
          />
        </div>
        <div className="flex items-center justify-between gap-2 flex-col bg-primary px-2 pb-2 pt-2">

          {devedorFilaSelected && devedorFilaSelected?._id && !attendantFirstMessage && <TemplateTransbordo />}


          <div className={`flex flex-col w-full `}>
            {/* <MessageBox type={type} setShowEmoji={setShowEmoji} showEmoji={showEmoji} clienteMess={clientMess} /> */}
            {
              devedorFilaSelected && devedorFilaSelected._id && clientMess && attendantFirstMessage && (
                <>
                  {/* ESTADO 0 — Preparando microfone */}
                  {isPreparing && (
                    <div className="flex items-center w-full bg-gray-100 rounded px-2 h-10 gap-2">
                      <span className="relative flex h-3 w-3 shrink-0">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-yellow-400 opacity-75" />
                        <span className="relative inline-flex rounded-full h-3 w-3 bg-yellow-500" />
                      </span>
                      <span className="text-yellow-600 text-sm flex-1">Preparando microfone...</span>
                    </div>
                  )}

                  {/* ESTADO 1 — Gravando */}
                  {isRecording && (
                    <div className="flex items-center w-full bg-gray-100 rounded px-2 h-10 gap-2">
                      <span className="relative flex h-3 w-3 shrink-0">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" />
                        <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500" />
                      </span>
                      <span className="text-red-500 text-sm font-medium">{formatDuration(recordingDuration)}</span>
                      <span className="text-xs text-gray-500 flex-1">Gravando...</span>
                      <button onClick={cancelRecording} title="Cancelar" className="hover:text-red-600 text-gray-500">
                        <Trash2 size={18} />
                      </button>
                      <button onClick={stopRecording} title="Parar" className="bg-red-600 rounded-full p-1 ml-1">
                        <Square size={10} className="fill-white text-white" />
                      </button>
                    </div>
                  )}

                  {/* ESTADO 2 — Revisão */}
                  {!isRecording && audioUrl && (
                    <div className="flex items-center w-full bg-gray-100 rounded px-2 h-10 gap-2">
                      <audio ref={audioPreviewRef} src={audioUrl} onEnded={() => setIsPlayingPreview(false)} className="hidden" />
                      <button onClick={togglePreview} title={isPlayingPreview ? "Pausar" : "Ouvir"}>
                        {isPlayingPreview
                          ? <Pause size={18} className="fill-primary text-primary" />
                          : <Play size={18} className="fill-primary text-primary" />}
                      </button>
                      <span className="text-xs text-gray-500 font-mono">{formatDuration(recordingDuration)}</span>
                      <div className="flex-1 h-1 bg-gray-300 rounded-full overflow-hidden">
                        <div className="h-full bg-primary" style={{
                          width: isPlayingPreview ? '100%' : '0%',
                          transition: isPlayingPreview ? `width ${recordingDuration}s linear` : 'none',
                        }} />
                      </div>
                      <button onClick={cancelRecording} title="Descartar" className="hover:text-red-600 text-gray-500">
                        <Trash2 size={18} />
                      </button>
                      <button onClick={sendAudio} disabled={isSendingAudio} title="Enviar áudio"
                        className="bg-green-600 rounded-full p-1 ml-1 disabled:opacity-50">
                        <IoSend size={14} className="fill-white text-white" />
                      </button>
                    </div>
                  )}

                  {/* ESTADO 3 — Input padrão */}
                  {!isRecording && !isPreparing && !audioUrl && (
                    <div className="flex items-center w-full justify-between">
                      <div className="flex h-10 w-full items-center rounded bg-gray-100 px-2">
                        <button onClick={() => setShowEmoji(!showEmoji)}>
                          <GrEmoji size={20} color={'#696969'} />
                        </button>
                        {fileState ? (
                          <div className="w-full flex items-center h-10 text-xs justify-between px-2">
                            <BsFileTextFill size={16} className="fill-primary" />
                            <p className="w-[140px] text-ellipsis whitespace-nowrap overflow-hidden">Arquivo: {fileState?.name}</p>
                            <button onClick={() => clearFile()}>
                              <IoMdClose size={16} className="fill-primary" />
                            </button>
                          </div>
                        ) : (
                          <textarea
                            className="flex h-10 w-full resize-none items-center rounded bg-transparent px-2 pt-2.5 text-sm outline-none"
                            placeholder="Escreva sua mensagem…"
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                            onKeyDown={handleKeyPress}
                          />
                        )}
                        {type !== "sms" && <FileButton onFileSelect={handleFileSelect} token={cookies?.whatsapp?.token || ''} />}
                        {!text && !fileState && (
                          <button onClick={startRecording} title="Gravar áudio" className="ml-1 hover:text-primary text-gray-500">
                            <Mic size={18} />
                          </button>
                        )}
                      </div>
                      <button className="w-[10%] ml-4 text-center"
                        onClick={() => attachments && attachments?.length > 0 ? handleSendFile() : handleSend({
                          type: 'text',
                          text: text,
                          onlySave: false,
                          token: cookies?.whatsapp?.token || '',
                          chat: devedorFilaSelected._id
                        })}>
                        <IoSend size={22} className="fill-white" />
                      </button>
                    </div>
                  )}
                </>
              )
            }
            {devedorFilaSelected?._id && (
              <div className="flex items-center gap-2">
                <button className="p-2 w-full bg-green-600 text-xs text-white font-semibold rounded-md mt-2" onClick={() => setShowModalTransfer(true)}>
                  Transferir
                </button>
                <button className="p-2 w-full bg-red-600 text-xs text-white font-semibold rounded-md mt-2" onClick={() => setShowModal(true)}>
                  {!clientMess ? 'Cancelar conversa' : 'Encerrar conversa'}
                </button>
              </div>
            )}

          </div>


        </div>
        {
          isMutationChat > 0 ? <div className=" flex justify-center  items-center min-h-[100%] w-[100%] absolute m bg-white opacity-90 z-50 px-4 py-4">
            <Loader size={3.5} />
          </div> : <></>
        }
      </div>

      <CustomModal isOpen={showModal} onClose={() => setShowModal(false)} title={''} width="w-[20%]">
        <div>
          <div className="flex items-center justify-center flex-col px-4">
            <p className="font-medium text-center text-lg m-2 text-gray-800 w-full">Deseja encerrar o atendimento?</p>
            <div className="flex items-center gap-4 text-sm w-full">
              <button type="button" className="bg-primary text-white px-4 py-2 rounded-md mt-4 w-full" onClick={() => setShowModal(false)}>Continuar</button>
              <button type="button" className="bg-error text-white px-4 py-2 rounded-md mt-4 w-full" onClick={() => handleEndChat()}>Finalizar </button>
            </div>
          </div>
        </div>
      </CustomModal>

      <TransferModal onClose={() => setShowModalTransfer(false)} open={showModalTransfer} chatId={devedorFilaSelected?._id} />

      <ModalFileUploadError message='O tamanho do vídeo é maior do que permitido (16 Megas), não pode ser enviado por este canal!' isOpen={isBigDuration} closeModal={() => seIsBigDuration(false)} />
      {/* <ModalFileUploadError message='O vídeo tem um tempo de duração maior que 2 minutos, Não é permitido enviar por este canal acima deste tempo!' isOpen={isBigDuration} closeModal={() => seIsBigDuration(false)} /> */}
    </div>
  );
};
